import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import {
  Paper, Box, Typography, Chip, Button, List, ListItem, ListItemText,
  CircularProgress, Divider,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { API_URL } from "../config";

// 教員/管理者ホーム用: 危険度上位の学生を要約表示するカード。
// 既存の /admin/at-risk/students（リスク順）を利用。
export default function AtRiskSummaryCard({ topN = 6 }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios
      .get(`${API_URL}/admin/at-risk/students`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((r) => setRows(r.data.students))
      .catch((e) => setErr(e?.response?.data?.detail || "取得に失敗しました"));
  }, []);

  const absent = rows?.filter((r) => r.not_in_classroom?.length > 0).length ?? 0;
  const dRisk = rows?.filter((r) => r.d_risk).length ?? 0;
  const top = rows?.slice(0, topN) ?? [];

  return (
    <Paper sx={{ p: 2, mb: 3, border: "1px solid", borderColor: "error.dark" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", color: "#fff" }}>
          <WarningAmberIcon sx={{ mr: 1, color: "#ff5252" }} /> 要注意学生（留年リスク）
        </Typography>
        <Button component={RouterLink} to="/admin/at-risk" size="small" variant="outlined">
          一覧を見る
        </Button>
      </Box>

      {err && <Typography color="error" variant="body2">{err}</Typography>}
      {!rows && !err && <CircularProgress size={22} color="inherit" />}

      {rows && (
        <>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <Chip color="error" label={`Classroom未参加 ${absent}名`} />
            <Chip color="warning" label={`D評価リスク ${dRisk}名`} />
          </Box>
          <Divider sx={{ my: 1 }} />
          <List dense disablePadding>
            {top.map((s, i) => (
              <ListItem key={s.student_id} disablePadding sx={{ py: 0.3 }}>
                <ListItemText
                  primary={
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={{ color: "#bbb", width: 20 }}>{i + 1}.</span>
                      <strong>{s.student_id}</strong>
                      <span>{s.name}</span>
                      <Chip size="small" label={s.program}
                        color={s.program === "通信" ? "info" : "default"} />
                      {s.not_in_classroom?.length > 0 && (
                        <Chip size="small" color="error"
                          label={`未参加 ${s.not_in_classroom.join("/")}`} />
                      )}
                      {s.d_risk && (
                        <Chip size="small" color="warning"
                          label={`D ${s.d_risk_subjects.join("/")}`} />
                      )}
                      <span style={{ color: "#ff9800" }}>
                        提出率 {s.submit_rate == null ? "—" : `${s.submit_rate}%`}
                      </span>
                    </Box>
                  }
                />
              </ListItem>
            ))}
            {top.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                要注意学生はいません 🎉
              </Typography>
            )}
          </List>
        </>
      )}
    </Paper>
  );
}
